import { render } from "./historyPage.vue?vue&type=template&id=1ee01f7d"
import script from "./historyPage.vue?vue&type=script&lang=js"
export * from "./historyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__